import React from "react";
import { useDrawerAnimation } from "../../../../shared/animation";
import { TertiaryLink } from "../../../TertiaryLink";
import * as S from "../styles";
export var LearnDrawerContent = function LearnDrawerContent(_ref) {
  var e = _ref.active,
      r = _ref.categories;
  return useDrawerAnimation(e)(function (e, t) {
    return t ? React.createElement(S.DrawerPrimaryContent, {
      style: e,
      "data-testid": "desktop-menu-drawer-learn"
    }, React.createElement(S.CategoryContainer, null, Object.keys(r).map(function (e) {
      return React.createElement(S.SubMenuCardWrapper, {
        key: e,
        href: r[e].url
      }, React.createElement(S.SubMenuCard, null, React.createElement(S.SubMenuCardImage, {
        src: r[e].imageSrc,
        alt: r[e].imageAlt
      }), React.createElement(TertiaryLink, null, e)));
    }))) : null;
  });
};